export enum EStatus {
  CONFIRMED = 'Order Confirmed',
  IN_PROGRESS = 'Delivery In Progress',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
}

export enum ETransferStatus {
  PENDING_APPROVAL = 'Pending Approval',
  IN_TRANSIT = 'In Transit',
  IN_PROGRESS = 'Delivery In Progress',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
  REJECTED = 'Rejected',
}

export enum EPaymentType {
  Cash = 'Cash',
  Cheque = 'Cheque',
  Card = 'Card',
  Bkash = 'Bkash',
  Nagad = 'Nagad',
}

export enum ESourceTransactionType {
  Sales = 'Sales',
  Purchases = 'Purchase',
  Return = 'Return',
  Damage = 'Damage',
  Expense = 'Expense',
  TransferIn = 'Transfer In',
  TransferOut = 'Transfer Out',
  StockTransfer = 'Stock Transfer',
}

export enum EReturnStatus {
  CONFIRMED = 'Return_Confirmed',
  COMPLETED = 'Completed',
  CANCELLED = 'Cancelled',
}

export enum ETemplateAttributeType {
  text = 'Text',
  float = 'Number',
  boolean = 'Boolean',
  dropdown = 'Dropdown',
}

export enum ManufactureStatus {
  'Not Started' = 'Not Started',
  'In Progress' = 'In Progress',
  'Done' = 'Done',
}

export enum EPaymentChannel {
  MFS = 'MFS',
  Bank = 'BANK',
  Card = 'CARD',
  Cash = 'CASH',
}

export enum ESalesChannel {
  POS = 'POS',
  RESTAURANT_POS = 'RESTAURANT_POS',
  SALES = 'SALES',
}
